import { createFileRoute } from "@tanstack/react-router";

import { ApiKeyCard } from "@/features/wonda/components/ApiKeyCard";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/api-key",
)({
  component: ApiKeyCard,
});
